import localizations from './localizations';

function namespacedLocalizations(key: string, namespace?: string) {
  if (namespace) {
    const namespacedValue = (localizations as any)[`${namespace}_${key}`];
    if (namespacedValue) return namespacedValue;
  }

  const stdValue = (localizations as any)[key];
  if (stdValue) return stdValue;

  return key;
}

export default namespacedLocalizations;